export default function findFirstUnusedSlot(arr: (number|undefined)[], slotsMaxSize: number): number {
  let result = 1
  const sortedSlotArr = arr
    .filter(x => typeof x === 'number')
    .sort((a, b) => (a || 0) - (b || 0))

  for(let i = 0; i < slotsMaxSize; i++) {
    if(i + 1 === sortedSlotArr[i]) { continue }
    result = i + 1
    break
  }

  return result
}
